export default {
    path: '/document',
    name: 'document',
    component: () => import('@/layouts/BaseLayout'),
    redirect: '/document/list',
    children: [
        {
            path: 'list',
            meta: { title: '文档列表', permission: 'document' },
            component: () => import('@/views/document/list/index'),
        },
        // 新增子页面时在此追加，例如：
        // {
        //   path: 'upload',
        //   meta: { title: '文档上传', permission: 'document_upload' },
        //   component: () => import('@/views/document/upload/index'),
        // },
    ],
}